export const policyMask = '0-0-000-0000000'